import HeadMeta from "@components/Theme/HeadMeta/HeadMeta"
import {getPosts} from "@config/modules"
import getValueOrThrow from "@helpers/getValueOrError"
import {getTranslatedPageData} from "@hooks/PagesData/getTranslatedPageData"
import Logos from "@jsons/customerStoriesLogos.json"
import StudioOverview from "@jsons/studioOverview.json"
import StudioPricing from "@jsons/studioPricing.json"
import CustomerLogosSection from "@pages/Studio/PricingPage/CustomerLogosSection/CustomerLogosSection"
import FAQSection from "@pages/Studio/PricingPage/FAQSection/FAQSection"
import PackagesSection from "@pages/Studio/PricingPage/PackagesSection/PackagesSection"
import React from "react"

type Props = {}

const pricing = (props: Props) => {
	const pageData = getTranslatedPageData(StudioPricing, undefined, true)
	getTranslatedPageData(StudioOverview, true)
	const logos = getPosts("logosModule", {data: Logos})

	const mainContent = getValueOrThrow(pageData.AdvancedSideAsset)

	return (
		<>
			<HeadMeta meta={pageData.metaData} />

			<PackagesSection
				cards={getValueOrThrow(pageData.pricingCardData)}
				data={mainContent[0]}
			/>
			<CustomerLogosSection data={logos} pageData={mainContent[1]} />

			<FAQSection
				faq={getValueOrThrow(pageData.faqData)}
				pageData={mainContent[2]}
			/>
		</>
	)
}

export default pricing
